// HeroBackground.tsx
import Image from "next/image";
import { images } from "@/public";

import { HeroBackgroundProps, Theme } from "@/src/utilities";
import { THEME } from "@/src/utilities/constants/constants";

// Type-safe env variable
const theme = THEME as Theme;
/**
 *
 * @param children
 * @param className
 * @description HeroBackground component is a component that is used to display the background of the hero section of the website based on the theme
 * @returns
 */
export default function HeroBackground({
  children,
  className,
}: HeroBackgroundProps) {
  if (theme === "orange") {
    return (
      <div className="relative w-screen h-auto md:h-screen overflow-hidden bg-gradient-to-r from-[#571400] to-[#eb5d00]">
        <Image
          src={images.background}
          alt=""
          fill
          className="object-cover"
          priority
        />
        <div className="relative z-10">{children}</div>
      </div>
    );
  }

  // Default: white theme
  return (
    <div className={`relative bg-aims-gradient ${className || ""}`}>
      <Image
        src={images.Ellipse2}
        alt=""
        width={200}
        height={200}
        className="absolute -top-10 left-0"
      />
      <Image
        src={images.Ellipse1}
        alt=""
        width={200}
        height={200}
        className="absolute left-0 top-65"
      />
      <div className="relative z-10">{children}</div>
    </div>
  );
}
